import { InvestmentObjectiveType, PlannedServiceType } from 'api/types/entity';
import { LegalClientInvestmentPurposeAndNatureParam } from 'api/types/params';

import { InvestmentPurposeAndNatureFormType } from '../../forms/investmentPurposeAndNatureForm';

export const getSubmitData = (
  values: InvestmentPurposeAndNatureFormType
): LegalClientInvestmentPurposeAndNatureParam => ({
  otherInvestmentObjective: values.investmentObjectives.find(
    (v) => v.value === InvestmentObjectiveType.Other
  )
    ? values.otherInvestmentObjective
    : null,

  otherPlannedServices: values.plannedServices.find(
    (v) => v.value === PlannedServiceType.Other
  )
    ? values.otherPlannedServices
    : null,
  investmentDuration: values.investmentDuration.value,
  investmentObjectives: values.investmentObjectives?.map((v) => v.value),
  plannedServices: values.plannedServices?.map((v) => v.value),
});
